import React, { useEffect, useState } from 'react';
import { useVideosActions } from 'src/store/videos/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { RootState } from 'src/store/reducers/state';
import Loader from 'src/components/loader';
import { CSVLink } from 'react-csv';
import Select from 'react-select';
import { useUserActions } from 'src/store/users/actions';
import { defaultDateFormatter } from 'src/components/utilities/utils';
import { SelectModel } from 'src/models/videosModel';
import { VideoAnalyticsFilterModel } from 'src/models/videosModel';
import AreaChart from 'src/components/charts/areachart/AreaChart';
import { successMsg } from 'src/components/utilities/utils';
import ToastMessage from 'src/components/ToastContainer';
import LiveInfoAnalytics from './LiveInfoAnalytics';
import { errorMsg } from 'src/components/utilities/utils';
import { customFilterOption } from 'src/components/utilities/utils';
import Pagination from 'src/components/common/pagination';
import * as XLSX from 'xlsx';
import DownloadModel from 'src/components/common/DownloadModel';
import moment from 'moment';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const VideoInfoAnalytics = () => {
  const dispatch = useDispatch();
  const userAction = useUserActions(dispatch);
  const { id } = useParams<string>();
  const localData = localStorage.getItem('userData');
  const navigate = useNavigate();
  const userData = localData && JSON.parse(localData);
  const isSA = userData?.role === 'Super Admin';
  const [downloadData, setDownloadData] = useState<any>();
  const [finalMemberList, setFinalMemberList] = useState<SelectModel[]>();
  const videoAction = useVideosActions(dispatch);
  const [showFilter, setShowFilter] = useState(false);
  const [finalRoles, setFinalRoles] = useState<SelectModel[]>();
  const [showTabFlag, setShowTabFlag] = useState<string>('all');
  const [filterMenu, setFilterMenu] = useState<string>('userName');
  const [triggerCSVDownload, setTriggerCSVDownload] = useState(false);
  const csvLinkRef = React.useRef<any>(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [analyticSessionFilter, setAnalyticSessionFilter] = useState('This Month');
  const [expandedMemberId, setExpandedMemberId] = useState<string | null>(null);

  const {
    videoAnalyticsData,
    isVideoAnalyticsDataLoading,
    singleVideo,
    videoAnalyticsChartData,
    roles,
    memberList,
    message,
    isVideoAnalyticsUpdated,
    error,
    paginationMeta,
    videoAnalyticsTable,
    videoAnalyticsTableDownload,
    isVideoAnalyticsTableLoading,
    videoViewingSession,
    isVideoViewingSessionLoading
  } = useSelector((state: RootState) => {
    return {
      videoAnalyticsData: state.videos.videoAnalyticsData,
      isVideoAnalyticsDataLoading: state.videos.isVideoAnalyticsDataLoading,
      singleVideo: state.videos.singleVideo,
      videoAnalyticsChartData: state.videos.videoAnalyticsChartData,
      roles: state.users.roles,
      memberList: state.users.memberList,
      message: state.videos.message,
      isVideoAnalyticsUpdated: state.videos.isVideoAnalyticsUpdated,
      error: state.videos.error,
      paginationMeta: state.videos.paginationMeta,
      videoAnalyticsTable: state.videos.videoAnalyticsTable,
      videoAnalyticsTableDownload: state.videos.videoAnalyticsTableDownload,
      isVideoAnalyticsTableLoading: state.videos.isVideoAnalyticsTableLoading,
      videoViewingSession: state.videos.videoViewingSession,
      isVideoViewingSessionLoading: state.videos.isVideoViewingSessionLoading
    };
  });
  useEffect(() => {
    if (memberList && memberList.length) {
      const options = memberList.map((item: any) => ({
        value: item.id,
        label: item.name
      }));
      setFinalMemberList([{ value: '', label: 'Select Member Type' }, ...options]);
    }
  }, [memberList]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control
  } = useForm<VideoAnalyticsFilterModel>();
  const [areaChartData, setAreaChartData] = useState({
    labels: [''],
    datasets: [
      {
        fill: true,
        lineTension: 0.4,
        label: '',
        data: [1],
        borderColor: '',
        backgroundColor: ''
      }
    ]
  });

  const handlePageChange = (pageNumber: number) => {
    const payloadData = { id, pageNumber: pageNumber, pageSize: 20 };
    videoAction.getVideoAnalyticsTableRequest(payloadData);
    setExpandedMemberId(null);
  };
  useEffect(() => {
    if (videoAnalyticsChartData) {
      if (singleVideo && singleVideo.videoContentType === 1) {
        setAreaChartData({
          labels: videoAnalyticsChartData && videoAnalyticsChartData.map((data) => data.date),
          datasets: [
            {
              fill: true,
              lineTension: 0.4,
              label: 'On-Demand Views',
              data:
                videoAnalyticsChartData &&
                videoAnalyticsChartData.map((data) => data.onDemandViews),
              borderColor: 'rgb(53, 162, 235)',
              backgroundColor: 'rgb(53, 162, 235)'
            },

            {
              fill: true,
              lineTension: 0.4,
              label: 'Total Views',
              data:
                videoAnalyticsChartData && videoAnalyticsChartData.map((data) => data.totalViews),
              borderColor: 'rgb(255,99,132)',
              backgroundColor: 'rgb(255,99,132)'
            }
          ]
        });
      } else {
        setAreaChartData({
          labels: videoAnalyticsChartData && videoAnalyticsChartData.map((data) => data.date),
          datasets: [
            {
              fill: true,
              lineTension: 0.4,
              label: 'On-Demand Views',
              data:
                videoAnalyticsChartData &&
                videoAnalyticsChartData.map((data) => data.onDemandViews),
              borderColor: 'rgb(53, 162, 235)',
              backgroundColor: 'rgb(53, 162, 235)'
            },
            {
              fill: true,
              lineTension: 0.4,
              label: 'Live Views',
              data:
                videoAnalyticsChartData && videoAnalyticsChartData.map((data) => data.liveViews),
              borderColor: 'rgb(123,51,206)',
              backgroundColor: 'rgb(123,51,206)'
            },
            {
              fill: true,
              lineTension: 0.4,
              label: 'Total Views',
              data:
                videoAnalyticsChartData && videoAnalyticsChartData.map((data) => data.totalViews),
              borderColor: 'rgb(255,99,132)',
              backgroundColor: 'rgb(255,99,132)'
            }
          ]
        });
      }
    }
  }, [videoAnalyticsChartData, singleVideo]);
  useEffect(() => {
    if (id) {
      const payloadData = { id, pageNumber: 1, pageSize: 20 };
      const videoFromDate = moment().startOf('month').format('YYYY-MM-DD');
      const videoToDate = moment().endOf('month').format('YYYY-MM-DD');
      videoAction.getVideoAnalyticsDataRequest(id);
      videoAction.getVideoAnalyticsChartDataRequest({ id, videoFromDate, videoToDate });
      videoAction.getVideoAnalyticsTableRequest(payloadData);
    }
  }, []);

  const handleUpdateClick = () => {
    if (id) {
      videoAction.updateVideoAnalyticsRequest(id);
    }
  };

  useEffect(() => {
    if (isVideoAnalyticsUpdated) {
      successMsg(message);
      videoAction.resetVideoLibraryRequest();
    }
  }, [isVideoAnalyticsUpdated]);

  useEffect(() => {
    if (id) {
      videoAction.getSingleVideosRequest(id);
    }
  }, [id]);

  const handleFilterClick = () => {
    if (showFilter) {
      setShowFilter(false);
    } else {
      setShowFilter(true);
    }
  };
  useEffect(() => {
    if (showFilter && !memberList.length && !roles.length) {
      userAction.getRolesRequest();
      userAction.getMemberListRequest({ pageNumber: 1, pageSize: 10000 });
    }
  }, [showFilter]);
  useEffect(() => {
    if (roles && roles.length) {
      const options = roles.map((item: any) => ({
        value: item.id,
        label: item.name
      }));
      setFinalRoles(options);
    }
  }, [roles]);
  useEffect(() => {
    if (memberList && memberList.length) {
      const options = memberList.map((item: any) => ({
        value: item.id,
        label: item.name
      }));
      setFinalMemberList([{ value: '', label: 'Select Member Type' }, ...options]);
    }
  }, [memberList]);

  const onSubmit = (data: any) => {
    const roleIds = data.RoleIds && data.RoleIds.map((item: any) => item.value);
    const payloadData = {
      ...data,
      id,
      pageNumber: 1,
      MemberTypesId: data.MemberTypesId?.value,
      RoleIds: roleIds
    };
    videoAction.getVideoAnalyticsTableRequest(payloadData);
    setExpandedMemberId(null);
  };

  useEffect(() => {
    if (error) {
      errorMsg('Error');
      videoAction.resetVideoLibraryRequest();
    }
  }, [error]);

  const getDarkBgColorStr = (perc: any) => {
    return perc < 25
      ? 'rgba(255, 31, 31, 1)'
      : perc < 50
        ? 'rgba(255, 165, 31, 1)'
        : perc < 75
          ? 'rgba(31, 143, 255, 1)'
          : 'rgba(31, 255, 31, 1)';
  };
  const getLightBgColorStr = (perc: any) => {
    return perc < 25
      ? 'rgba(255, 198, 184, 1)'
      : perc < 50
        ? 'rgba(255, 216, 158, 1)'
        : perc < 75
          ? 'rgba(191, 219, 254, 1)'
          : 'rgba(213, 255, 199, 1)';
  };

  const handleToggleSessions = (memberId: string) => {
    if (!memberId || !id) return;
    if (expandedMemberId === memberId) {
      setExpandedMemberId(null);
      return;
    }
    setExpandedMemberId(memberId);
    videoAction.getVideoViewingSessionRequest({ videoId: id, memberId });
  };

  const formatDuration = (totalSeconds: any) => {
    const seconds = Number(totalSeconds) || 0;
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    const pad = (n: number) => String(n).padStart(2, '0');
    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
  };

  const handleConfirmDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    setDownloadProgress(0);
    let allData: any[] = [];
    let pageNumber = 1;
    const pageSize = 20;
    let totalPages = 1;
    const rootUrl = process.env.REACT_APP_BASE_API_URL;
    const bearerToken = localStorage.getItem('token');

    if (!bearerToken) {
      console.error('No token found in localStorage');
      errorMsg('Authentication token not found');
      setIsDownloading(false);
      return;
    }

    try {
      console.log('Starting download for video ID:', id);

      // Fetch all pages sequentially
      while (pageNumber <= totalPages || pageNumber === 1) {
        const apiPath = `/v2/analytics/video/${id}`;
        const apiUrl = `${rootUrl}${apiPath}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        console.log(`Fetching page ${pageNumber} at URL: ${apiUrl}`);
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            'Content-Type': 'application/json'
          }
        });

        const pageData = response.data.result.map((analytics: any) => ({
          firstName: analytics.firstName || '',
          lastName: analytics.lastName || '',
          email: analytics.email || '',
          userName: analytics.userName || '',
          totalWatchedDuration: analytics.totalWatchedDuration || '',
          percentageWatched: analytics.percentageWatched || '',
          liveViews: analytics.liveViews || '',
          onDemandViews: analytics.onDemandViews || '',
          totalViews: (analytics.liveViews || 0) + (analytics.onDemandViews || 0),
          firstWatch: analytics.firstWatch ? defaultDateFormatter(analytics.firstWatch) : '',
          lastWatch: analytics.lastWatch ? defaultDateFormatter(analytics.lastWatch) : ''
        }));
        allData = [...allData, ...pageData];

        // Update totalPages after the first request
        if (pageNumber === 1) {
          totalPages = Math.ceil(response.data.totalCount / pageSize);
          console.log(
            `Total pages calculated: ${totalPages}, Total count: ${response.data.totalCount}`
          );
        }

        setDownloadProgress((pageNumber / totalPages) * 100);
        pageNumber++;
      }

      if (allData.length === 0) {
        console.warn('No data fetched for download');
        errorMsg('No data available to download');
        return;
      }

      // Format data for CSV
      const csvData = [
        ['Title:', singleVideo?.title || ''],
        ['Date:', singleVideo?.recordDate || ''],
        ['Total Live Views:', videoAnalyticsData?.liveViews || ''],
        ['Total Ondemand Views:', videoAnalyticsData?.onDemandViews || ''],
        ['Total Unique Views:', videoAnalyticsData?.uniqueViews || ''],
        ['Total Views:', videoAnalyticsData?.totalViews || ''],
        ['First Watch:', videoAnalyticsData?.firstWatch || ''],
        ['Last Watch:', videoAnalyticsData?.lastWatch || ''],
        ['Total Time Watched:', videoAnalyticsData?.totalWatchedDuration || ''],
        ['Average Time Watched:', videoAnalyticsData?.averageWatchedDuration || ''],
        ['Last Update:', videoAnalyticsData?.lastModifiedDate || ''],
        [''],
        [
          'First Name',
          'Last Name',
          'Email',
          'UserName',
          'Total Watched Duration',
          'Percentage Watched',
          'Live Views',
          'OnDemand Views',
          'Total Views',
          'First Watch',
          'Last Watch'
        ],
        ...allData.map((analytics) => [
          analytics.firstName,
          analytics.lastName,
          analytics.email,
          analytics.userName,
          analytics.totalWatchedDuration,
          analytics.percentageWatched,
          analytics.liveViews,
          analytics.onDemandViews,
          analytics.totalViews,
          analytics.firstWatch,
          analytics.lastWatch
        ])
      ];

      // Generate CSV using SheetJS
      const ws = XLSX.utils.aoa_to_sheet(csvData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'VideoAnalytics');
      XLSX.writeFile(wb, 'VideoAnalytics.csv');

      successMsg('Download completed successfully');
      console.log('Download completed with', allData.length, 'records');
    } catch (err) {
      console.error('Download error:', err);
      errorMsg('Failed to download data');
    } finally {
      setIsDownloading(false);
      setDownloadProgress(0);
    }
  };

  const handleAnalyticsChartFilterClick = (data: string) => {
    if (id) {
      setAnalyticSessionFilter(data);
      if (data === 'This Week') {
        const videoFromDate = moment().startOf('week').format('YYYY-MM-DD');
        const videoToDate = moment().endOf('week').format('YYYY-MM-DD');
        videoAction.getVideoAnalyticsChartDataRequest({ id, videoFromDate, videoToDate });
      } else if (data === 'Last Week') {
        const videoFromDate = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
        const videoToDate = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
        videoAction.getVideoAnalyticsChartDataRequest({ id, videoFromDate, videoToDate });

      } else if (data === 'This Month') {
        const videoFromDate = moment().startOf('month').format('YYYY-MM-DD');
        const videoToDate = moment().endOf('month').format('YYYY-MM-DD');
        videoAction.getVideoAnalyticsChartDataRequest({ id, videoFromDate, videoToDate });

      } else if (data === 'Last Month') {
        const videoFromDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        const videoToDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        videoAction.getVideoAnalyticsChartDataRequest({ id, videoFromDate, videoToDate });

      } else if (data === 'This Year') {
        const videoFromDate = moment().startOf('year').format('YYYY-MM-DD');
        const videoToDate = moment().endOf('year').format('YYYY-MM-DD');
        videoAction.getVideoAnalyticsChartDataRequest({ id, videoFromDate, videoToDate });
      }
    }
  };

  const handleVideoQuizResult = (memberId: string, videoId: any, email: string) => {
    window.open(`/videoQuizResult/${videoId}/${memberId}?email=${encodeURIComponent(email)}`, '_blank');
  };
  return (
    <>
      <div>
        <ToastMessage />
        {videoAnalyticsData && (
          <div className="dashboard-card my-5 py-4">
            <Link to={`/videos/${id}`}>
              <i className="fas fa-arrow-left"></i>
              <span className="ml-2">Go Back</span>
            </Link>
            <div className="lg:flex items-center justify-between">
              <h2 className="font-semibold mb-4">{singleVideo && singleVideo.title}</h2>
              <div>
                <div className="md:flex items-center">
                  {
                    isSA && (
                      <>
                        <p className="mr-1">
                          Last Update:
                          {videoAnalyticsData.lastUpdated ? videoAnalyticsData.lastUpdated : ''}
                        </p>
                        <button
                          type="button"
                          onClick={handleUpdateClick}
                          className="btn-primary w-auto mt-0 mr-3 ml-0 borderonly-btn mb-3 md:mb-0">
                          Run Update
                        </button>
                      </>
                    )
                  }
                  {/* <button
                    type="submit"
                    className="btn-primary w-auto mt-0 mr-3 ml-0 borderonly-btn">
                    Analytics
                  </button> */}
                  <div className="flex items-center">
                    <div className="dropdown relative">
                      <button
                        className="dropdown-toggle border input-style w-32 mr-3 flex-items export-dropdown"
                        type="button"
                        id="action-dropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <span className="flex">Analytics </span>
                        <img src="../../assets/img/down-icon.svg" className="w-4 h-4" />
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-ul w-32 cursor-pointer"
                        aria-labelledby="action-dropdown">
                        <li onClick={() => setShowTabFlag('live')} className="text-center">
                          <span>Live Views</span>
                        </li>
                        <li onClick={() => setShowTabFlag('all')} className="text-center">
                          <span>All Views</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {
                  isSA && (
                    <p className="mt-2 text-right">
                      {videoAnalyticsData.queueToProcess
                        ? 'There are new views.  Run Update to retrieve latest analytics.'
                        : 'There are no new views after the last analytics run.'}
                    </p>

                  )}

              </div>
            </div>
            {showTabFlag === 'all' ? (
              <div>
                <div className="my-6">
                  <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:gap-4 lg:gap-4 md:gap-2 gap-1 mb-2">
                    <div className="analytics-box navy-bg flex justify-between">
                      <span>Total Views</span> <span>{videoAnalyticsData.totalViews}</span>
                    </div>
                    {singleVideo && singleVideo.videoContentType !== 1 && (
                      <div className="analytics-box purple-bg flex justify-between">
                        <span>Live Viewers</span> <span>{videoAnalyticsData.liveViews}</span>
                      </div>
                    )}
                    <div className="analytics-box light-green-bg flex justify-between">
                      <span>OnDemand</span> <span>{videoAnalyticsData.onDemandViews}</span>
                    </div>
                    <div className="analytics-box navy-bg flex justify-between">
                      <span>Unique Viewers</span> <span>{videoAnalyticsData.uniqueViews}</span>
                    </div>
                  </div>
                  <div>
                    {!!videoAnalyticsTable?.length && (
                      <div>
                        <button
                          className="btn-primary w-auto mt-0 mr-0 ml-auto borderonly-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#downloadModel">
                          Download
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <div>
                    {singleVideo && singleVideo.recordDate && (
                      <p>
                        <i>Date: {singleVideo.recordDate ? singleVideo.recordDate : ''}</i>
                      </p>
                    )}
                    {videoAnalyticsData.firstWatch && (
                      <p>
                        First Watch:{' '}
                        {videoAnalyticsData.firstWatch ? videoAnalyticsData.firstWatch : ''}
                      </p>
                    )}
                    {videoAnalyticsData.lastWatch && (
                      <p>
                        Last Watch:{' '}
                        {videoAnalyticsData.lastWatch ? videoAnalyticsData.lastWatch : ''}
                      </p>
                    )}
                    {videoAnalyticsData.totalWatchedDuration && (
                      <p>Total Time Watched: {videoAnalyticsData.totalWatchedDuration}</p>
                    )}
                    {videoAnalyticsData.averageWatchedDuration && (
                      <p>Average Watched: {videoAnalyticsData.averageWatchedDuration}</p>
                    )}
                  </div>
                </div>
                <div>
                  <div className='flex justify-end'>
                    <div className="dropdown relative mr-3">
                      <button
                        className="whitespace-nowrap dropdown-toggle border input-style w-28 mx-auto flex-items export-dropdown p-2"
                        type="button"
                        id="action-dropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <span className="flex">{analyticSessionFilter}</span>
                        <img src="../../assets/img/down-icon.svg" className="w-4 h-4 ml-2" />
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-ul w-32 cursor-pointer"
                        aria-labelledby="action-dropdown">
                        <li>
                          <span
                            className="action-menu flex items-center"
                            onClick={() => handleAnalyticsChartFilterClick('This Week')}>
                            <span>This Week</span>
                          </span>
                        </li>
                        <li>
                          <span
                            className="action-menu flex items-center"
                            onClick={() => handleAnalyticsChartFilterClick('Last Week')}>
                            <span>Last Week</span>
                          </span>
                        </li>
                        <li>
                          <span
                            className="action-menu flex items-center"
                            onClick={() => handleAnalyticsChartFilterClick('This Month')}>
                            <span>This Month</span>
                          </span>
                        </li>
                        <li>
                          <span
                            className="action-menu flex items-center"
                            onClick={() => handleAnalyticsChartFilterClick('Last Month')}>
                            <span>Last Month</span>
                          </span>
                        </li>
                        <li>
                          <span
                            className="action-menu flex items-center"
                            onClick={() => handleAnalyticsChartFilterClick('This Year')}>
                            <span>This Year</span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <AreaChart chartData={areaChartData} />
                </div>

                <div className={`mt-5`}>
                  <div>
                    <button
                      type="button"
                      className="btn-primary w-auto mt-0 mr-0 ml-auto borderonly-btn"
                      onClick={handleFilterClick}>
                      <i className="fa fa-filter" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div className={`mb-5 ${showFilter ? '' : 'hidden'}`}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="md:flex flex-wrap items-center mb-4">
                        <div className="lg:pr-4 xl:w-1/4 lg:w-1/2 w-full">
                          <div className={`form-group lg:mt-6 mt-3 w-full`}>
                            <input
                              className="input-style"
                              type="text"
                              placeholder="Username/email"
                              {...register('UserNameOrEmail')}
                            />
                          </div>
                        </div>
                        <div className="lg:pr-4 xl:w-1/4 lg:w-1/2 w-full">
                          <div className={`form-group lg:mt-6 mt-3 w-full`}>
                            {finalRoles && Object.keys(finalRoles).length && (
                              <Controller
                                render={({
                                  field: { onChange, onBlur, value, ref },
                                  fieldState: { error }
                                }) => (
                                  <Select
                                    filterOption={customFilterOption}
                                    placeholder="Roles"
                                    options={finalRoles}
                                    isMulti
                                    value={value}
                                    id="RoleIds"
                                    onChange={(val) => onChange(val)}
                                  />
                                )}
                                name="RoleIds"
                                control={control}
                              />
                            )}
                          </div>
                        </div>

                        <div className="lg:pr-4 xl:w-1/4 lg:w-1/2 w-full">
                          <div className={`form-group lg:mt-6 mt-3 w-full`}>
                            {finalMemberList && Object.keys(finalMemberList).length && (
                              <Controller
                                render={({
                                  field: { onChange, onBlur, value, ref },
                                  fieldState: { error }
                                }) => (
                                  <Select
                                    filterOption={customFilterOption}
                                    placeholder="Select Member Type"
                                    options={finalMemberList}
                                    value={value}
                                    id="MemberTypesId"
                                    onChange={(val) => onChange(val)}
                                  />
                                )}
                                name="MemberTypesId"
                                control={control}
                              />
                            )}
                          </div>
                        </div>

                        <div className="lg:pr-4 xl:pr-0 xl:w-1/4 lg:w-1/2 w-full">
                          <div className={`form-group w-full lg:mt-6 mt-3`}>
                            <button
                              type="submit"
                              className="btn-primary lg:w-full mt-0 w-56 ml-0 borderonly-btn">
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <select className="input-style" onChange={(e) => setFilterMenu(e.target.value)}>
                      <option value="userName">UserName</option>
                      <option value="email">Email</option>
                      <option value="fullName">FullName</option>
                    </select>
                  </div>
                </div>
                <div className="overflow-x-auto">
                  <table className="table-auto w-full my-6">
                    <thead className="text-xs font-semibold uppercase bg-gray-50">
                      <tr>
                        <th className="p-2">
                          <div className="font-semibold text-left">
                            {filterMenu === 'userName'
                              ? 'User Name'
                              : filterMenu === 'email'
                                ? 'Email'
                                : filterMenu === 'fullName'
                                  ? 'Full Name'
                                  : 'User Name'}
                          </div>
                        </th>

                        {singleVideo && singleVideo.videoContentType !== 1 && (
                          <th className="p-2">
                            <div className="font-semibold text-left">Live Views</div>
                          </th>
                        )}

                        <th className="p-2">
                          <div className="font-semibold text-left">OnDemand Views</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Total Time Watched</div>
                        </th>

                        <th className="p-2">
                          <div className="font-semibold text-left">First Watch</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Last Watch</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Credits Achieved</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Credit Type</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Credits Sent</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-center">Quiz</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Percentage Watched</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-center">
                            <p>OnDemand Milestones</p>
                            <div className="flex gap-2">
                              <div className="w-10 mx-auto text-center">25%</div>
                              <div className="w-10 mx-auto text-center">50%</div>
                              <div className="w-10 mx-auto text-center">75%</div>
                              <div className="w-10 mx-auto text-center">90%</div>
                              <div className="w-10 mx-auto text-center">100%</div>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {isVideoAnalyticsTableLoading && (
                        <tr>
                          <td>
                            <Loader />
                          </td>
                        </tr>
                      )}
                      {videoAnalyticsTable &&
                        videoAnalyticsTable.map((item: any, index) => {
                          const hasSessions =
                            (item.liveViews && item.liveViews > 0) ||
                            (item.onDemandViews && item.onDemandViews > 0);
                          const isRowExpanded = expandedMemberId === item.memberId;
                          const colCount =
                            singleVideo && singleVideo.videoContentType !== 1 ? 12 : 11;

                          return (
                            <React.Fragment key={index}>
                              <tr className="border-b">
                                <td className="p-2">
                                  <div className="text-left">
                                    {' '}
                                    {filterMenu === 'userName'
                                      ? `${item.userName}`
                                      : filterMenu === 'email'
                                        ? `${item.email}`
                                        : filterMenu === 'fullName'
                                          ? `${item.firstName} ${item.lastName}`
                                          : `${item.userName}`}
                                  </div>
                                </td>
                                {singleVideo && singleVideo.videoContentType !== 1 && (
                                  <td className="p-2">
                                    <div
                                      className={`text-left ${hasSessions ? 'cursor-pointer' : ''}`}
                                      onClick={() =>
                                        hasSessions && handleToggleSessions(item.memberId)
                                      }>
                                      {item.liveViews}
                                    </div>
                                  </td>
                                )}
                                <td className="p-2">
                                  <div
                                    className={`text-left ${hasSessions ? 'cursor-pointer' : ''}`}
                                    onClick={() =>
                                      hasSessions && handleToggleSessions(item.memberId)
                                    }>
                                    {item.onDemandViews}
                                  </div>
                                </td>
                                <td className="p-2">
                                  <div className="text-left">{item.totalWatchedDuration}</div>
                                </td>

                                <td className="p-2">
                                  <div className="text-left">
                                    {item.firstWatch ? defaultDateFormatter(item.firstWatch) : ''}
                                  </div>
                                </td>
                                <td className="p-2">
                                  <div className="text-left">
                                    {item.lastWatch ? defaultDateFormatter(item.lastWatch) : ''}
                                  </div>
                                </td>
                                <td className="p-2">
                                  <div className="text-left">
                                    <div className="text-left">{item.creditPointsAchieved}</div>
                                  </div>
                                </td>

                                <td className="p-2 text-center">
                                  <div className="flex flex-col items-center gap-1">
                                    {item.userCredits && item.userCredits.length > 0 ? (
                                      item.userCredits.map((credit: any, idx: number) => (
                                        <span
                                          key={idx}
                                          className="px-2 py-1 text-xs rounded-md bg-gray-200 text-gray-700 text-center w-fit">
                                          {credit.displayCreditsAchieved}
                                        </span>
                                      ))
                                    ) : (
                                      <span className="text-gray-400">—</span>
                                    )}
                                  </div>
                                </td>

                                <td className="p-2">
                                  <div className="text-left">
                                    <div className="text-left">
                                      {item.creditsSent ? (
                                        <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td className="p-2 text-center">
                                  {item.quizAttended ? (
                                    <i
                                      className="fa fa-poll text-lg text-primary cursor-pointer"
                                      title="View quiz attempts"
                                      onClick={() => handleVideoQuizResult(item.memberId, id, item.email)}
                                    ></i>
                                  ) : (
                                    <i className="fa fa-poll text-lg text-gray-300" title="No quiz attempts"></i>
                                  )}
                                </td>
                                <td className="p-2">
                                  <div className="text-left">
                                    {item.percentageWatched}%
                                    <div
                                      className="w-full bg-blue-200 h-1 rounded-md mt-2"
                                      style={{
                                        backgroundColor: `${getLightBgColorStr(
                                          item.percentageWatched
                                        )}`
                                      }}>
                                      <div
                                        className="bg-blue-600 h-1 rounded-md"
                                        style={{
                                          width: `${item.percentageWatched}%`,
                                          backgroundColor: `${getDarkBgColorStr(
                                            item.percentageWatched
                                          )}`
                                        }}></div>
                                    </div>
                                  </div>
                                </td>
                                <td className="p-2">
                                  <div className="flex gap-2">
                                    {item.milestone25 ? (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                      </div>
                                    ) : (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-times text-danger text-lg text-red-700"></i>
                                      </div>
                                    )}
                                    {item.milestone50 ? (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                      </div>
                                    ) : (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-times text-danger text-lg text-red-700"></i>
                                      </div>
                                    )}
                                    {item.milestone75 ? (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                      </div>
                                    ) : (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-times text-danger text-lg text-red-700"></i>
                                      </div>
                                    )}
                                    {item.milestone90 ? (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                      </div>
                                    ) : (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-times text-danger text-lg text-red-700"></i>
                                      </div>
                                    )}
                                    {item.milestone100 ? (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                      </div>
                                    ) : (
                                      <div className="w-10 mx-auto text-center">
                                        <i className="fa fa-times text-danger text-lg text-red-700"></i>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>


                              {isRowExpanded && expandedMemberId != null && (
                                <>
                                  {isVideoViewingSessionLoading ? (
                                    <tr className="bg-gray-50">
                                      <td className="p-3" colSpan={colCount}>
                                        <Loader />
                                      </td>
                                    </tr>
                                  ) : videoViewingSession && videoViewingSession.length ? (
                                    videoViewingSession.map((session: any) => (
                                      <tr
                                        key={session.sessionId}
                                        className="border-b bg-gray-50 italic text-gray-500">
                                        <td className="p-2">
                                          <div className="text-left">
                                            {session.videoType === 'Live'
                                              ? 'Live session'
                                              : 'OnDemand session'}
                                          </div>
                                        </td>

                                        {singleVideo && singleVideo.videoContentType !== 1 && (
                                          <td className="p-2">
                                            <div className="text-left">
                                              {session.videoType === 'Live' ? 1 : ''}
                                            </div>
                                          </td>
                                        )}
                                        <td className="p-2">
                                          <div className="text-left">
                                            {session.videoType === 'OnDemand' ? 1 : ''}
                                          </div>
                                        </td>
                                        <td className="p-2">
                                          <div className="text-left">
                                            {formatDuration(session.totalTimeWatched)}
                                          </div>
                                        </td>
                                        <td className="p-2">
                                          <div className="text-left">
                                            {session.firstWatch
                                              ? defaultDateFormatter(session.firstWatch)
                                              : ''}
                                          </div>
                                        </td>
                                        <td className="p-2">
                                          <div className="text-left">
                                            {session.lastWatch
                                              ? defaultDateFormatter(session.lastWatch)
                                              : ''}
                                          </div>
                                        </td>
                                        <td className="p-2">
                                          <div className="text-left">—</div>
                                        </td>
                                        <td className="p-2 text-center">
                                          <span className="text-gray-400">—</span>
                                        </td>
                                        <td className="p-2">
                                          <div className="text-left">—</div>
                                        </td>
                                        <td className="p-2 text-center">—</td>
                                        <td className="p-2">
                                          <div className="text-left">—</div>
                                        </td>
                                        <td className="p-2">
                                          <div className="flex gap-2">
                                            {[
                                              session.milestone25,
                                              session.milestone50,
                                              session.milestone75,
                                              session.milestone90,
                                              session.milestone100
                                            ].map((reached, idx) => (
                                              <div key={idx} className="w-10 mx-auto text-center">
                                                {reached ? (
                                                  <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                                ) : (
                                                  <i className="fa fa-times text-danger text-lg text-red-700"></i>
                                                )}
                                              </div>
                                            ))}
                                          </div>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr className="bg-gray-50">
                                      <td
                                        className="p-3 text-center text-gray-400"
                                        colSpan={colCount}>
                                        No sessions found.
                                      </td>
                                    </tr>
                                  )}
                                </>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </table>
                  {!!paginationMeta && !!Object.keys(paginationMeta).length && (
                    <Pagination
                      currentPage={paginationMeta.pageNumber}
                      totalCount={paginationMeta.totalCount}
                      pageSize={paginationMeta.pageSize}
                      onPageChange={(page: any) => handlePageChange(page)}
                    />
                  )}
                </div>
              </div>
            ) : (
              <LiveInfoAnalytics />
            )}
          </div>
        )}
      </div>

      {!!videoAnalyticsTable && !!Object.keys(videoAnalyticsTable).length && (
        <DownloadModel
          isDownloading={isDownloading}
          downloadProgress={downloadProgress}
          handleConfirmDownload={handleConfirmDownload}
        />
      )}
    </>
  );
};

export default VideoInfoAnalytics;